var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass:
        "cw-block cw-block-biography cw-block-biography-personal-information",
    },
    [
      _c("courseware-default-block", {
        attrs: {
          block: _vm.block,
          canEdit: _vm.canEdit,
          isTeacher: _vm.isTeacher,
          preview: true,
        },
        on: {
          closeEdit: _vm.initCurrentData,
          showEdit: _vm.setShowEdit,
          storeEdit: _vm.storeBlock,
        },
        scopedSlots: _vm._u(
          [
            {
              key: "content",
              fn: function fn() {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "cw-block-biography-content",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "cw-block-biography-type cw-block-biography-personal-information-type",
                        },
                        [_c("h2", [_vm._v(_vm._s(_vm.currentData.name))])]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "cw-block-biography-details cw-block-biography-personal-information-details",
                        },
                        [
                          _c(
                            "span",
                            [
                              _c("translate", [_vm._v("Geburtsort")]),
                              _vm._v(":"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.currentData.birthplace)),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("translate", [_vm._v("Geburtsdatum")]),
                              _vm._v(":"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getReadableDate(_vm.currentData.birthday)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("translate", [_vm._v("Geschlecht")]),
                              _vm._v(":"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.displayGenderText(_vm.currentData.gender)
                              )
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "span",
                            [
                              _c("translate", [_vm._v("Familienstand")]),
                              _vm._v(":"),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.displayStatusText(_vm.currentData.status)
                              )
                            ),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.canEdit
              ? {
                  key: "edit",
                  fn: function fn() {
                    return [
                      _c(
                        "form",
                        {
                          staticClass: "default",
                          on: {
                            submit: function submit($event) {
                              $event.preventDefault()
                            },
                          },
                        },
                        [
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Name")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.name,
                                    expression: "currentData.name",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentData.name,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "name",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Geburtsort")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.birthplace,
                                    expression: "currentData.birthplace",
                                  },
                                ],
                                attrs: {
                                  type: "text",
                                },
                                domProps: {
                                  value: _vm.currentData.birthplace,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "birthplace",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Geburtsdatum")]),
                              _vm._v(" "),
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.currentData.birthday,
                                    expression: "currentData.birthday",
                                  },
                                ],
                                attrs: {
                                  type: "date",
                                },
                                domProps: {
                                  value: _vm.currentData.birthday,
                                },
                                on: {
                                  input: function input($event) {
                                    if ($event.target.composing) {
                                      return
                                    }

                                    _vm.$set(
                                      _vm.currentData,
                                      "birthday",
                                      $event.target.value
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Geschlecht")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentData.gender,
                                      expression: "currentData.gender",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })

                                      _vm.$set(
                                        _vm.currentData,
                                        "gender",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "none",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayGenderText("none"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "male",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayGenderText("male"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "female",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayGenderText("female"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "diverse",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayGenderText("diverse"))
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "label",
                            [
                              _c("translate", [_vm._v("Familienstand")]),
                              _vm._v(" "),
                              _c(
                                "select",
                                {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.currentData.status,
                                      expression: "currentData.status",
                                    },
                                  ],
                                  on: {
                                    change: function change($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })

                                      _vm.$set(
                                        _vm.currentData,
                                        "status",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "none",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayStatusText("none"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "single",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayStatusText("single"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "married",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayStatusText("married"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "widowed",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.displayStatusText("widowed"))
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "divorced",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.displayStatusText("divorced")
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "registered-civil-partnership",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.displayStatusText(
                                            "registered-civil-partnership"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "option",
                                    {
                                      attrs: {
                                        value: "annulled-civil-partnership",
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.displayStatusText(
                                            "annulled-civil-partnership"
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "info",
              fn: function fn() {
                return [
                  _c("translate", [
                    _vm._v(
                      "Informationen zum Persönlichen-Informationen-Block"
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }